import { Component, Input } from "@angular/core";
import { InviteListConfig, User } from "../../../../models";

@Component({
  selector: "invite-alert-button",
  templateUrl: "./invite-alert-button.component.html",
  styleUrls: [
    "./invite-alert-button.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class InviteAlertButtonComponent {
  public hasNotifications: boolean = false;
  @Input() limit: number;
  @Input() config: InviteListConfig;
  @Input() currentUser: User;

  constructor() {}

  ngOnInit() {}

  public alertUser(event) {
    this.hasNotifications = event;
  }
}
